export default __webpack_public_path__ + "static/Certification_Badge-b24bf273f16794a8d444c533bfdb30f2.png";